<template>
  <div
    class="container"
    oncopy="return false"
    oncut="return false"
    onpaste="return false"
  >
    <div
      v-if="loading"
      class="row"
    >
      <div class="col-lg-12 col-xs-12 videoPainel bg-white p-3 shadow_bar">
        <sweetalert-icon icon="loading" />
      </div>
    </div>
    <div
      v-else
      class="row"
    >
      <div class="col-lg-12 col-xs-12 videoPainel bg-white p-3 shadow_bar mb-5">
        <div
          v-if="show_evaluation_start"
          class="row"
        >
          <div class="col-lg-12 col-xs-12">
            <h3
              style="color: #000"
              class="center"
            >
              {{ evaluations[setup_index].evaluation.name }}
            </h3>
          </div>
          <div
            v-if="evaluations[setup_index].evaluation.description"
            class="col-lg-12 col-xs-12 ml-5 mr-5"
            style="max-width: fit-content; word-wrap: break-word;"
          >
            <span
              style="color: #000"
              v-html="evaluations[setup_index].evaluation.description"
            />
          </div>
        </div>
        <div
          v-if="show_evaluation_start"
          class="row"
        >
          <div class="col-lg-4 col-xs-12 mt-3" />
          <div class="col-lg-4 col-xs-12 mt-3">
            <button
              @click="showEvaluationStart(false)"
              class="btn btn-primary full"
            >
              Iniciar prova
            </button>
          </div>
          <div class="col-lg-4 col-xs-12 mt-3" />
        </div>
        <div v-if="!show_evaluation_start">
          <div class="row">
            <div class="col-lg-12 col-xs-12">
              <h3
                style="color: #000"
                class="center"
              >
                Responda as perguntas:
              </h3>
            </div>
          </div>
          <div
            v-if="total_steps > 1"
            class="row"
          >
            <div class="col-12 pl-3 pr-3">
              <transition
                name="fade"
                mode="out-in"
                apper
              >
                <StepIndicator
                  class="mt-3"
                  defaultColor="#53358b"
                  :currentColor="'#00a0d6'"
                  :current="setup_index"
                  :total="total_steps"
                ></StepIndicator>
              </transition>
            </div>
          </div>
          <div class="row">
            <div class="col-12 pl-3 pr-3">
              <div class="tab">
                <div class="row mt-3">
                  <div class="col-12">
                    <div
                      class="f18"
                      style="color: #000 !important"
                      v-html="mountTitle"
                    >
                    </div>
                  </div>
                </div>
                <hr />
                <div
                  class="row mb-3"
                  v-if="evaluations[setup_index].questions[question_index].response_type == text_type"
                >
                  <div class="col-lg-12 col-12">
                    <TextType
                      :question="evaluations[setup_index].questions[question_index]"
                      :index="question_index"
                      :currentTime="currentTime"
                      :is_evaluation="true"
                      @nextQuestion="nextQuestion"
                    />
                  </div>
                </div>
                <div
                  class="row mb-3"
                  v-if="evaluations[setup_index].questions[question_index].response_type == video_type"
                >
                  <div class="col-lg-3 col-12" />
                  <div class="col-lg-6 col-12">
                    <VideoJSRecord
                      :question="evaluations[setup_index].questions[question_index]"
                      :index="question_index"
                      :currentTime="currentTime"
                      v-if="!ios"
                      :is_evaluation="true"
                      @nextQuestion="nextQuestion"
                    />
                  </div>
                  <div class="col-lg-3 col-12" />
                </div>
                <div
                  class="row  mb-3"
                  v-if="evaluations[setup_index].questions[question_index].response_type == multiple_choices_type"
                >
                  <div class="col-lg-12 col-12">
                    <MultipleChoices
                      :question="evaluations[setup_index].questions[question_index]"
                      :index="question_index"
                      :currentTime="currentTime"
                      :is_evaluation="true"
                      @nextQuestion="nextQuestion"
                    />
                  </div>
                </div>
                <div
                  class="row  mb-3"
                  v-if="evaluations[setup_index].questions[question_index].response_type == yer_or_no_type"
                >
                  <div class="col-lg-12 col-12">
                    <YesOrNo
                      :question="evaluations[setup_index].questions[question_index]"
                      :index="question_index"
                      :currentTime="currentTime"
                      :is_evaluation="true"
                      @saveAnswers="nextQuestion"
                    />
                  </div>
                </div>
                <div
                  class="row  mb-3"
                  v-if="evaluations[setup_index].questions[question_index].response_type == monetary_type"
                >
                  <div class="col-lg-12 col-12">
                    <MonetaryType
                      :question="evaluations[setup_index].questions[question_index]"
                      :index="question_index"
                      :currentTime="currentTime"
                      :is_evaluation="true"
                      @saveAnswers="nextQuestion"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col">
            <div style="text-align:center;margin-top:40px;">
              <span>
                Questão {{ question_index + 1 }} de {{ evaluations[setup_index].questions.length }}
              </span>
            </div>
          </div>
        </div>
        <div
          v-if="is_timer_counting"
          class="row"
        >
          <div class="col">
            <p style="font-size: 16px; color: black"><b>{{ timer_minute }}:{{ timer_secound <= 9 ? "0"+timer_secound : timer_secound  }}</b></p>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import StepIndicator from "vue-step-indicator";
import VideoJSRecord from "components/VideoJSRecord.vue";
import VideoJSRecordMobile from "components/VideoJSRecordMobile.vue";
import MultipleChoices from "pages/Jobs/MultipleChoices.vue";
import TextType from "pages/Jobs/TextType.vue";
import YesOrNo from "pages/Jobs/YesOrNo.vue";
import MonetaryType from "pages/Jobs/MonetaryType.vue";

import {
  isMobile,
  mobileModel,
  osName,
  isChrome,
  isSafari,
  mobileVendor,
} from "mobile-device-detect";

export default {
  props: ["evaluations", "candidate"],

  components: {
    StepIndicator,
    VideoJSRecord,
    VideoJSRecordMobile,
    MultipleChoices,
    TextType,
    YesOrNo,
    MonetaryType,
  },

  data() {
    return {
      timer_secound: 59,
      timer_minute: 99,
      question_index: 0,
      setup_index: 0,
      total_steps: 0,
      video_type: 0,
      text_type: 1,
      multiple_choices_type: 2,
      yer_or_no_type: 3,
      monetary_type: 4,
      evaluation_answer: {},
      ios: false,
      timer: 0,
      currentTime: 0,
      show_evaluation_start: true,
      loading: true,
      is_timer_counting: false,
    };
  },
  computed: {
    mountTitle() {
      if (
        this.evaluations[this.setup_index].questions[this.question_index]
          .details
      ) {
        return (
          this.evaluations[this.setup_index].questions[this.question_index]
            .title +
            `<p class='f14'>` +
            this.evaluations[this.setup_index].questions[this.question_index]
              .details || "" + `</p>`
        );
      }
      return this.evaluations[this.setup_index].questions[this.question_index]
        .title;
    },
  },
  mounted() {
    if (localStorage.getItem("timer_second") && localStorage.getItem("timer_second") !== "end") {
      this.timer_secound = localStorage.getItem("timer_second");
    }
    if (localStorage.getItem("timer_minute") && localStorage.getItem("timer_minute") !== "end") {
      this.timer_minute = localStorage.getItem("timer_minute");
    }
    if (localStorage.getItem("timer_second") && localStorage.getItem("timer_second") == "end") {
      localStorage.setItem("timer_second", this.timer_secound);
      localStorage.setItem("timer_minute", this.timer_minute);
    }
    this.total_steps = this.evaluations.length;

    if (this.evaluations[this.setup_index].questions.length == 0) {
      this.nextEvaluation();
    } else {
      this.evaluation_answer = {
        question_id:
          this.evaluations[this.setup_index].questions[this.question_index].id,
      };
    }

    if (mobileModel == "iPhone") {
      this.ios = true;
    }

    if (
      (isMobile || mobileVendor == "Apple" || mobileVendor == "none") &&
      isSafari
    ) {
      this.ios = true;
    }

    if (isMobile && osName == "Android" && !isChrome) {
      this.ios = true;
    }
    this.startTimer();
    this.countFocusPage();
    document.addEventListener("contextmenu", (event) => event.preventDefault());
    document.addEventListener("keyup", (e) => {
      if (e.key == "PrintScreen") {
        navigator.clipboard.writeText("");
      }
    });

    document.addEventListener("keydown", (e) => {
      if (
        e.ctrlKey &&
        (e.code == "KeyP" || e.code == "KeyS" || e.code == "KeyU")
      ) {
        e.cancelBubble = true;
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    });

    document.addEventListener("keydown", (e) => {
      if (e.ctrlKey && e.shiftKey && (e.code == "KeyC" || e.code == "KeyI")) {
        e.cancelBubble = true;
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    });
    document.addEventListener("keydown", (e) => {
      if (e.code == "F12") {
        e.cancelBubble = true;
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    });
    this.loading = false;
  },
  methods: {
    nextQuestion(answer) {
      if (this.validateAnswer(answer)) {
        this.loading = true;
        this.answer = "";
        this.stopTimer();
        this.startTimer();
        if (
          this.question_index !==
          this.evaluations[this.setup_index].questions.length - 1
        ) {
          this.evaluation_answer = {
            question_id:
              this.evaluations[this.setup_index].questions[
                this.question_index + 1
              ].id,
          };
        } else {
          this.evaluation_answer = {
            question_id:
              this.evaluations[this.setup_index].questions[this.question_index]
                .id,
          };
        }
        axios
          .post("/candidates/answers", { answers: this.evaluation_answer })
          .then((response) => {
            if (response.data.answer !== null) {
              if (
                this.question_index !==
                this.evaluations[this.setup_index].questions.length - 1
              ) {
                this.question_index = this.question_index + 1;
                return this.nextQuestion("skip_validation");
              } else {
                return this.nextEvaluation();
              }
            }
            if (
              this.question_index !==
              this.evaluations[this.setup_index].questions.length - 1
            ) {
              this.question_index = this.question_index + 1;
              this.loading = false;
            } else {
              this.nextEvaluation();
            }
          });
      }
    },
    validateAnswer(answer) {
      if (answer && answer !== "") {
        return true;
      }
      this.$toast.error("Responda a questão para continuar");
      return false;
    },
    nextEvaluation() {
      if (this.setup_index === this.evaluations.length -1) {
        eventBus.$emit("finalScreen", { status: true });
        return;
      }
      this.setup_index = this.setup_index + 1;
      this.question_index = 0;

      if (this.evaluations[this.setup_index].questions[this.question_index]){ 
        this.evaluation_answer = {
          question_id:
            this.evaluations[this.setup_index].questions[this.question_index].id,
        };
      }
      this.loading = false;
      this.showEvaluationStart(true);
    },
    startTimer() {
      this.timer = setInterval(() => {
        this.currentTime += 1;
      }, 1000);
    },
    stopTimer() {
      window.clearInterval(this.timer);
      this.currentTime = 0;
    },
    showEvaluationStart(status) {
      if (!status && !this.is_timer_counting) {
        this.is_timer_counting = true;
        axios
          .put("/candidates", {
            candidates: {
              view_evaluation: this.candidate.view_evaluation + 1,
            },
          })
        setInterval(() => {
          if (localStorage.getItem("timer_second") && localStorage.getItem("timer_second") == "end") {
            return
          }
          if (this.timer_minute <= 0 && this.timer_secound <= 1) {
            axios
              .put("/candidates", {
                candidates: {
                  view_evaluation: 3,
                },
              })
              .then((response) => {});
            eventBus.$emit("finalScreen", { status: true });
            return;
          }
          this.timer_secound = this.timer_secound - 1;
          if (this.timer_secound <= 0) {
            this.timer_minute = this.timer_minute - 1;
            this.timer_secound = 60;
          }
          localStorage.setItem("timer_second", this.timer_secound);
          localStorage.setItem("timer_minute", this.timer_minute);
        }, 1000);
      }
      this.show_evaluation_start = status;
    },
    countFocusPage() {
      window.addEventListener('blur', () => {
        if (this.is_timer_counting == true){
          axios
          .post("/candidates/apply/add_count_blur_view", { 
          question_id: this.evaluation_answer.question_id 
          })
          .then(() => {})
        }
      });
    },
    truncate(title) {
      return title.length > 50
        ? title.slice(0, 50).trim().concat("...")
        : title;
    },
  },

  watch: {
    show_evaluation_start() {
      if (!this.show_evaluation_start){
        axios
          .post("/candidates/answers", { answers: this.evaluation_answer })
          .then((response) => {
            if (response.data.answer !== null) {
              this.nextQuestion("skip_validation");
            } else {
              this.loading = false;
            }
          });
      }
    }
  }
};
</script>

<style>
.step {
  height: 15px;
  width: 15px;
  margin: 0 2px;
  background-color: #bbbbbb;
  border: none;
  border-radius: 50%;
  display: inline-block;
  opacity: 0.5;
}
.step-active {
  opacity: 1;
}
</style>